import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? '15px' : '20px',
      overflow: 'auto',
    }}>
      <div style={{
        width: '100%',
        maxWidth: isMobile ? '500px' : '1200px',
        display: isMobile ? 'flex' : 'grid',
        flexDirection: isMobile ? 'column' : undefined,
        gridTemplateColumns: isMobile ? undefined : '1fr 1fr',
        gap: isMobile ? '30px' : '60px',
        alignItems: 'center',
      }}>
        {/* Branding Side */}
        <div style={{ 
          color: 'white',
          textAlign: isMobile ? 'center' : 'left',
        }}>
          <img 
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="Loop Logo" 
            style={{
              width: isMobile ? '180px' : '220px',
              height: isMobile ? '150px' : '180px',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1) drop-shadow(0 10px 30px rgba(0,0,0,0.3))',
            }}
          />
          {/* <h1 style={{ 
            fontSize: isMobile ? '32px' : '48px', 
            fontWeight: '700', 
            marginBottom: isMobile ? '12px' : '20px',
            margin: 0,
          }}>
            Loop
          </h1> */}
          <p style={{ 
            fontSize: isMobile ? '16px' : '20px', 
            marginBottom: isMobile ? '20px' : '30px', 
            opacity: 0.9,
            margin: 0,
            marginTop: isMobile ? '12px' : '20px',
          }}>
            Stay Connected, Stay in the Loop
          </p>
          
          <div style={{
            height: '3px',
            width: '100%',
            background: 'rgba(255, 255, 255, 0.3)',
            marginBottom: isMobile ? '20px' : '30px',
            marginTop: isMobile ? '20px' : '30px',
          }} />
          <h2 style={{ 
            fontSize: isMobile ? '20px' : '24px', 
            fontWeight: '600', 
            marginBottom: '10px', 
            margin: 0,
          }}>
            Smart Networking Assistant
          </h2>
          <p style={{ 
            fontSize: isMobile ? '14px' : '16px', 
            opacity: 0.8, 
            lineHeight: 1.6, 
            margin: 0, 
            marginTop: '10px',
          }}>
            Keep your professional network active with intelligent follow-ups and relationship management
          </p>

          {!isMobile && (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '15px', 
              marginTop: '30px',
            }}>
              <div style={{
                display: 'flex',
                gap: '15px',
                padding: '20px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
              }}>
                <div style={{ fontSize: '24px' }}>👥</div>
                <div>
                  <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600', marginBottom: '5px' }}>
                    Network Management
                  </h4>
                  <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                    Organize and track your professional connections with ease
                  </p>
                </div>
              </div>
              <div style={{
                display: 'flex',
                gap: '15px',
                padding: '20px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
              }}>
                <div style={{ fontSize: '24px' }}>✉️</div>
                <div>
                  <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600', marginBottom: '5px' }}>
                    AI-Powered Messages
                  </h4>
                  <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                    Generate personalized follow-ups and outreach messages instantly
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Form Side */}
        <div style={{
          background: 'white',
          borderRadius: isMobile ? '20px' : '24px',
          padding: isMobile ? '30px 25px' : '50px',
          boxShadow: '0 25px 80px rgba(0, 0, 0, 0.3)',
          width: '100%',
        }}>
          <div style={{ 
            marginBottom: isMobile ? '30px' : '40px', 
            textAlign: 'center',
          }}>
            <h3 style={{ 
              fontSize: isMobile ? '26px' : '32px', 
              fontWeight: '700', 
              color: '#667eea', 
              marginBottom: '10px',
              margin: 0,
            }}>
              Welcome Back
            </h3>
            <p style={{ 
              fontSize: isMobile ? '14px' : '15px', 
              color: '#5a6c7d',
              margin: 0,
              marginTop: '10px',
            }}>
              Sign in to access your networking dashboard
            </p>
          </div>

          <form onSubmit={handleSubmit} style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: isMobile ? '20px' : '25px',
          }}>
            {error && (
              <div style={{
                padding: isMobile ? '14px' : '16px',
                borderRadius: '12px',
                fontSize: '14px',
                backgroundColor: '#fee',
                color: '#c00',
                border: '1px solid #fcc',
              }}>
                {error}
              </div>
            )}
            
            <div>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#667eea', 
                marginBottom: '8px',
              }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                autoFocus
                style={{
                  width: '100%',
                  padding: isMobile ? '14px' : '16px',
                  border: '2px solid #e0e7ef',
                  borderRadius: '12px',
                  fontSize: '15px',
                  outline: 'none',
                  transition: 'all 0.3s',
                  boxSizing: 'border-box',
                }}
              />
            </div>

            <div>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#667eea', 
                marginBottom: '8px',
              }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                style={{
                  width: '100%',
                  padding: isMobile ? '14px' : '16px',
                  border: '2px solid #e0e7ef',
                  borderRadius: '12px',
                  fontSize: '15px',
                  outline: 'none',
                  transition: 'all 0.3s',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <div style={{ 
              textAlign: 'right', 
              marginTop: '-10px',
            }}>
              <span 
                onClick={() => navigate('/forgot-password')} 
                style={{ 
                  color: '#667eea', 
                  fontSize: '14px', 
                  fontWeight: '600', 
                  cursor: 'pointer',
                }}
              >
                Forgot Password?
              </span>
            </div>

            <button 
              type="submit" 
              disabled={loading}
              style={{
                width: '100%',
                padding: isMobile ? '16px' : '18px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: isMobile ? '16px' : '17px',
                fontWeight: '700',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
                marginTop: '10px',
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
          

          <div style={{ 
            marginTop: isMobile ? '25px' : '30px', 
            textAlign: 'center', 
            fontSize: isMobile ? '14px' : '15px', 
            color: '#5a6c7d',
          }}>
            <p style={{ margin: 0 }}>
              Don't have an account?{' '}
              <span 
                onClick={() => navigate('/register')} 
                style={{ color: '#667eea', fontWeight: '700', cursor: 'pointer' }}
              >
                Create Account
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;